/**
 * Format a number (or numeric string) as currency. Falls back to "1,234.56 CODE"
 * if the code is invalid or unsupported.
 */
export function formatAmount(
  value: number | string | null | undefined,
  currencyCode?: string
): string {
  if (value === null || value === undefined) return "";
  const amount = typeof value === "string" ? parseFloat(value) : value;
  if (Number.isNaN(amount)) return "";

  if (currencyCode) {
    try {
      // try the built-in
      return new Intl.NumberFormat(undefined, {
        style: "currency",
        currency: currencyCode,
        minimumFractionDigits: 2,
      }).format(amount);
    } catch {
      // fallback: "1,234.56 USDT"
      return `${amount.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })} ${currencyCode}`;
    }
  }

  // no code → plain number
  return amount.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}
